module.exports = __webpack_public_path__ + "media/images/fonts/lg-beffdb937a4d533b92aba9ac6a15467c.svg";